import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;

  ${media.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.desktop} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const GalleryItem = styled.img`
  width: 100%;
  height: 50px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;

  ${media.tablet} {
    height: 200px;
  }

  ${media.desktop} {
    height: 150px;
  }
`;
